<template>
  <div class="control-checkbox">
    <input type="checkbox" class="d-none" v-model="canMoveItems" id="can-move-items">
    <label
      for="can-move-items"
      class="d-block p-2 p-md-3 border border-2 rounded font-gotham-m fs-7"
      :class="[canMoveItems ? 'primary-border-color primary-text-color' : 'text-secondary border-secondary']"
    >
      Me interesa ver opciones de flete o mudanza a la bodega
    </label>
  </div>
</template>

<script>
export default {
  computed: {
    canMoveItems: {
      get () {
        return this.$store.state.warehouseRental.canMoveItems;
      },

      set (value) {
        this.$store.commit('setWarehouseRental', {
          canMoveItems: value
        });
      }
    }
  }
}
</script>
